import g1 from "../img/resource/guide-1.jpeg";
import g2 from "../img/resource/guide-2.jpeg";
import g3 from "../img/resource/guide-3.jpeg";
import g4 from "../img/resource/guide-4.jpeg";
import g5 from "../img/resource/guide-5.jpeg";
import g6 from "../img/resource/guide-6.jpeg";
import g7 from "../img/resource/guide-7.jpeg";
import g8 from "../img/resource/guide-8.jpeg";
import g9 from "../img/resource/guide-9.jpeg";
import g10 from "../img/resource/guide-10.jpeg";
import g11 from "../img/resource/guide-11.jpeg";
import g12 from "../img/resource/guide-12.jpeg";
import a1 from "../img/resource/article-1.jpeg";
import a2 from "../img/resource/article-2.jpeg";
import a3 from "../img/resource/article-3.jpeg";
import a4 from "../img/resource/article-4.jpeg";
import a5 from "../img/resource/article-5.jpeg";
import a6 from "../img/resource/article-6.jpeg";
import a7 from "../img/resource/article-7.jpeg";
import a8 from "../img/resource/article-8.jpeg";
import a9 from "../img/resource/article-9.jpeg";
import a10 from "../img/resource/article-10.jpeg";
import a11 from "../img/resource/article-11.jpeg";
import a12 from "../img/resource/article-12.jpeg";
import e1 from "../img/resource/ebook-1.jpeg";
import e2 from "../img/resource/ebook-2.jpeg";
import e3 from "../img/resource/ebook-3.jpeg";
import e4 from "../img/resource/ebook-4.jpeg";
import e5 from "../img/resource/ebook-5.jpeg";
import e6 from "../img/resource/ebook-6.jpeg";
import e7 from "../img/resource/ebook-7.jpeg";
import e8 from "../img/resource/ebook-8.jpeg";
import e9 from "../img/resource/ebook-9.jpeg";
import e10 from "../img/resource/ebook-10.jpeg";
import e11 from "../img/resource/ebook-11.jpeg";
const resourceCategories = [
  {
    id: `rT1`,
    category: `All`,
  },
  {
    id: `rT2`,
    category: `Car Insurance`,
  },
  {
    id: `rT3`,
    category: `Two Wheeler Insurance`,
  },
  {
    id: `rT4`,
    category: `Health Insurance`,
  },
  {
    id: `rT5`,
    category: `Group Health Insurance`,
  },
];
const mainContentData = [
  {
    page: `resources`,
    type: `resources`,
    heading: `Become an expert on insurance`,
    desc: `Subscribe to get curated insurance content in your inbox`,
  },
  {
    page: `articles`,
    type: `articles`,
    heading: `Articles to make insurance easy`,
    desc: `Subscribe to get curated insurance content in your inbox`,
  },
  {
    page: `guides`,
    type: `guides`,
    heading: `Guides to make insurance easy`,
    desc: `Subscribe to get curated insurance content in your inbox`,
  },
  {
    page: `ebooks`,
    type: `ebooks`,
    heading: `Ebooks`,
    desc: `Checkout ebooks on insurance`,
  },
];
const resourceData = [
  {
    id: "g1",
    category: `Two Wheeler Insurance`,
    type: "guides",
    img: g1,
    title: `Get started with Two Wheeler Insurance`,
  },
  {
    id: "g2",
    category: `Health Insurance`,
    type: "guides",
    img: g2,
    title: `Get started with Health Insurance`,
  },
  {
    id: "g3",
    category: `Group Health Insurance`,
    type: "guides",
    img: g3,
    title: `Get started with Group Health Insurance`,
  },
  {
    id: "g4",
    category: `Car Insurance`,
    type: "guides",
    img: g4,
    title: `Get started with Car Insurance`,
  },
  {
    id: "g5",
    category: `Two Wheeler Insurance`,
    type: "guides",
    img: g5,
    title: `Add-ons for Two Wheeler Insurance`,
  },
  {
    id: "g6",
    category: `Health Insurance`,
    type: "guides",
    img: g6,
    title: `Premium Calculator for Health Insurance`,
  },
  {
    id: "g7",
    category: `Group Health Insurance`,
    type: "guides",
    img: g7,
    title: `Add-ons for Group Health Insurance`,
  },
  {
    id: "g8",
    category: `Car Insurance`,
    type: "guides",
    img: g8,
    title: `Add-ons in Car Insurance`,
  },
  {
    id: "g9",
    category: `Two Wheeler Insurance`,
    type: "guides",
    img: g9,
    title: `Premium Calculator for Bike Insurance`,
  },
  {
    id: "g10",
    category: `Car Insurance`,
    type: "guides",
    img: g10,
    title: `All you need to know about Zero Depreciation`,
  },
  {
    id: "g11",
    category: `Car Insurance`,
    type: "guides",
    img: g11,
    title: `Premium Calculator for Car Insurance`,
  },

  {
    id: "g12",
    category: `Two Wheeler Insurance`,
    type: "guides",
    img: g12,
    title: `How to compare Bike Insurance policies`,
  },

  {
    id: "a1",
    category: `Two Wheeler Insurance`,
    type: "articles",
    img: a1,
    date: `Nov 12,2021`,
    title: `Essential Tips to Reduce Your Two Wheeler Insurance Premium`,
    article_url: `essential-tips-to-reduce-your-bike-insurance-premium`,
    mainContent: `In the Indian transport segment, two-wheelers occupy the biggest share compared to other vehicles. Bikes or scooters are a convenient way to move around congested and narrow roads. It is also important to insure the two-wheeler in case of any unfortunate damage or loss. It is mandatory to insure your bike with a third party insurance cover. To protect your bike you need to <a href="/two-wheeler-insurance">buy a comprehensive two-wheeler insurance</a> policy. While purchasing insurance coverage for your bike, it is important that you get maximum coverage at a lower premium. Here are some simple tips to reduce your two-wheeler insurance premium.`,
    moreContent: {
      contentType: `Common`,
      contentData: [
        {
          type: `Heading`,
          content: `How to Save on Your Two-Wheeler Insurance Premium?`,
        },
        {
          type: `Paragraph`,
          content: `It is natural to get the best at a lower cost when you are researching the best bike insurance policy in the market for your bike. This can be achieved if you are paying a lower two-wheeler insurance premium and receiving maximum coverage. Bike insurance premium includes several elements which affect the amount you pay to the insurance company. It is essential that you understand the components of the insurance premium so that you can make an informed decision before you buy or renew two-wheeler insurance.`,
        },
        {
          type: `Heading`,
          content: `Tips to Reduce Your Two-Wheeler Insurance Premium:`,
        },
        {
          type: `Paragraph`,
          content: `To get the best out of the insurance policy, you need to be aware of factors which influence the insurance rate. This will help you to get the lowest bike insurance price.`,
        },
        {
          type: `Paragraph`,
          content: `Below are a few of the important tips to reduce your bike insurance premium:`,
        },
        {
          type: "NumberedContent",
          content: [
            {
              heading: `Compare Insurance Policies`,
              para: [
                `Begin with comparing insurance policies available for your two-wheeler in the market. The best method to do that is to compare bike insurance online. The internet helps you connect with insurance companies who help you with two-wheeler insurance quotes. Check the coverage, additional benefits offered by insurers and ensure you find the most suitable bike insurance. Also, comparing insurance will reveal the policy, which offers higher coverage at a lower insurance premium.`,
              ],
            },
            {
              heading: `Avoid Raising Small Claims`,
              para: [
                `While renewing a bike insurance policy, the insurer will offer No Claim Bonus (NCB) if you have not raised any claim during the policy period. This can go up to 50%. Raising small or insignificant claims will avoid the discount in the form of NCB while renewing the policy. Hence, you will be paying a higher premium compared to a situation when you take advantage of the NCB as a discount.`,
              ],
            },
            {
              heading: `Choose Suitable Add-on Covers`,
              para: [
                `Add-on covers provide additional coverage to the standard comprehensive insurance policy. However, you need to pay an additional premium. By choosing unwanted or redundant add-ons you will only increase the bike insurance rate and not reduce the bike insurance premium.`,
              ],
            },
            {
              heading: `Renew Your Insurance Policy on Time`,
              para: [
                `Ensure you renew the bike insurance within the stipulated due date and do not let it lapse. When the motor insurance lapses, the NCB benefit is valid only for a period of 90 days from the due date and lapses later on. It is imperative that your bike insurance renewal is done before the due date to avoid a higher premium.`,
              ],
            },
            {
              heading: `Install Anti-Theft Devices`,
              para: [
                `Insurance companies offer lower bike insurance premiums if you secure your two-wheeler with security devices such as anti-theft alarms. It reflects your intent to secure your vehicle and avoid any unwanted damages or loss. Ensure the security devices are approved by the Automotive Research Association of India (ARAI) to avail the discount on the two-wheeler insurance premium.`,
              ],
            },
            {
              heading: `Buy From the Same Insurance Company`,
              para: [
                `If you have bought other types of insurance such as health, travel, etc. from a particular insurance company, buy the bike insurance policy from the same insurer. The insurance company may offer loyalty points which may be used as a discount on the bike insurance premium.`,
              ],
            },
            {
              heading: `No Claim Bonus (NCB)`,
              para: [
                `Whether you are renewing the insurance with the same insurer or with a new insurance company, ensure you make use of the NCB to discount the premium. If you are renewing with the same insurer, ensure you do not raise small claims so that you do not lose out on the NCB. Also, if you want to transfer the insurance, then get the NCB certificate from your current insurer to avail the NCB with the new insurer.`,
              ],
            },
            {
              heading: `Ask for Discounts`,
              para: [
                `There is no harm in asking for a discount while renewing or buying new insurance for your two-wheeler. To promote their insurance policies, insurers may offer discounts. Get discounts to reduce the bike insurance premium.`,
              ],
            },
            {
              heading: `Driving Records`,
              para: [
                `While you are awarded the NCB for driving safely and not raising any claims during the policy period, new-age digital insurance companies may review your driving habits to determine the premium. Ensure you maintain a good track record when it comes to your driving habits.`,
              ],
            },
            {
              heading: `Higher Deductible`,
              para: [
                `While settling the claim, the insurance company will not bear the entire cost of repair. You will have to pay a certain percentage which is known as a deductible. By opting to pay a higher deductible, the two-wheeler insurance premium reduces.`,
              ],
            },
            {
              heading: `Become a Member of Recognized Motor Riding Organization or Automobile Association`,
              para: [
                `Some motorcycle organizations or clubs offer discounts to their members towards insurance of their vehicle. If you are part of these organizations such as a touring club or an automobile association, avail the discount to reduce the bike insurance premium.`,
              ],
            },
          ],
        },
        {
          type: "Heading",
          content: `Is it Mandatory to Buy a Two-Wheeler Insurance Policy?`,
        },
        {
          type: `Paragraph`,
          content: `It is mandatory as per the Motor Vehicles Act to insure your bike at least with Third-party insurance. It is considered a traffic violation to ride a two-wheeler on Indian roads without valid insurance. However, it is not mandatory to insure the bike with comprehensive insurance, but it financially protects you in case of damage or loss to your two-wheeler. To reduce any financial implications due to damages or losses to your vehicle, insuring your vehicle with comprehensive coverage will avoid unnecessary expenses.`,
        },
      ],
    },
  },
  {
    id: "a2",
    category: `Car Insurance`,
    type: "articles",
    img: a2,
    date: `Dec 10,2021`,
    title: `5 Things to Know About Car Insurance for Beginners`,
    article_url: `5-things-to-know-about-car-insurance-for-beginners`,
    mainContent: `If you are new to car insurance, it might seem a bit complex and intimidating. Begin by understanding the very basics of this industry. In this article, we will shed light on some of the basic facts that will help you understand car insurance and eventually buy the most suitable insurance policy for your car.`,
    moreContent: {
      contentType: `Common`,
      contentData: [
        {
          type: "NumberedContent",
          content: [
            {
              heading: `Select a policy that suits your needs`,
              para: [
                `Remember that there are two types of car insurance policies – Third-party car insurance and Comprehensive policy. The former is mandatory by Indian law, however, more coverages and benefits are offered by the latter. If you wish to avail minimum coverage i.e. only against third-party liabilities, opt for third-party car insurance. However, if you want to protect your car as well, go for a Comprehensive policy.`,
              ],
            },
            {
              heading: `Set the IDV correctly`,
              para: [
                `IDV is a jargon related to car insurance that you will come across frequently while buying the policy. IDV stands for Insured Declared Value. It is the approximate current market price of your car. Note that IDV is not the resale value of your vehicle, it is more like a reference point for the current value. Remember that you do not need to set an IDV if you opt for third-party car insurance. You can only select the IDV range when you buy a Comprehensive policy.`,
                `In case your car gets stolen or meets with a major accident where it is damaged beyond repair, the car will be deemed as ‘total loss’. This is where IDV will come into the picture. Your insurance company (i.e. ACKO) will then compensate you the approximate IDV amount that you had set while buying the policy. Thus, it is very important to set the right IDV. Setting a higher amount will increase the car insurance prices, whereas setting a lower amount will reduce the claim amount.`,
              ],
            },
            {
              heading: `A higher deductible may lower the premium, but it also lowers the claim amount`,
              para: [
                `Ensure you renew the bike insurance within the stipulated due date and do not let it lapse. When the motor insurance lapses, the NCB benefit is valid only for a period of 90 days from the due date and lapses later on. It is imperative that your bike insurance renewal is done before the due date to avoid a higher premium.`,
                `A deductible is an amount that the policyholder needs to pay at the time of claim settlement. This is a small amount paid as a share by the policyholder. Basically, there are two kinds of deductibles in car insurance – compulsory and voluntary. You can choose the amount you wish to pay at the time of claim under the voluntary deductible. It is commonly believed that setting a higher deductible is fruitful for safe drivers. However, setting a higher deductible will result in a lower claim amount. Thus, be careful while setting a voluntary deductible.`,
              ],
            },
            {
              heading: `Only useful add-ons should be bought`,
              para: [
                `If you have opted for a Comprehensive car insurance policy, you will be given an option for selecting additional coverages i.e. add-ons. If you have a new car, you can select from a wide range of add-ons, for example, Zero Depreciation Add-On, Return to Invoice Cover, Roadside Assistance Cover, Engine Protection Add-On, No Claim Bonus (NCB) Cover, etc. Each add-on is to be bought separately. This will increase the cost of your policy. You need to select only those add-ons that suit your requirements. For example, if you think there are really less chances of raising a claim, you may skip NCB Cover.`,
              ],
            },
            {
              heading: `Timely renewal will help you retain your NCB`,
              para: [
                `It is not only necessary to buy an insurance policy, but also to keep it active at all times. Usually, a car insurance policy is valid for 1 year, long-term policies are also available. You need to renew your car insurance in time or else the policy will lapse. A lapsed policy is of no use and will not provide any kind of financial security to you or the third party. Also, you may lose the accumulated NCB i.e. the No Claim Bonus if you fail to renew the policy in time. NCB is a discount you receive on car insurance prices when you do not raise any claim. Since this discount can be as high as 50% for five consecutive claim-free years, you need to renew the policy in time to retain it. Not renewing post 90 days of the expiry of the policy, will lead to losing out on this benefit and also a higher premium amount during renewal time`,
              ],
            },
          ],
        },
        {
          type: `Paragraph`,
          content: `These were some of the basics that will help you understand the concept of car insurance. Remember to read the terms and conditions, exclusions, and the fine print mentioned on the policy document.`,
        },
      ],
    },
  },
  {
    id: "a3",
    category: `Health Insurance`,
    type: "articles",
    img: a3,
    date: `Apr 12,2021`,
    title: `Room Rent Capping Under Health Insurance Coverage (Room Rent Limit)`,
    article_url: `room-rent-limit`,
    mainContent: `After staying at a hospital for treatment, the patient has to pay a bill. This hospital bill consists of services that are availed during stay and treatment. If you notice, there are various items on the bill and one of the most important is the room rent. When a person is covered under Health Insurance, the bill is settled by the insurer and how room rent is calculated in the claim can be tricky for a few of us. <b>This article sheds light on what is room rent capping and how it affects the hospital bill.</b>`,
    moreContent: {
      contentData: [
        {
          type: `Heading`,
          content: `What is Room Rent Capping in Health Insurance?`,
        },
        {
          type: `Paragraph`,
          content: `Capping or a "cap" on something refers to its limit. Talking about the room rent capping in health insurance, it is the limit up to which your insurance company will bear the room rent. If you decide to stay in a hospital room that costs more than the cap, you will have to bear the additional money during the claim settlement.`,
        },
        {
          type: `Paragraph`,
          content: `The insurance company mentions the room rent cap in a health insurance policy document for your reference. It can either be a specific amount, for example, Rs. 15000, or in percentage, i.e. 3% of the sum insured. It can also be capped at a certain number for each day of hospitalization.`,
        },
        {
          type: `SmallHeading`,
          content: `For example:`,
        },
        {
          type: `Paragraph`,
          content: `Consider, Mr A bought an Individual Health insurance policy with a room rent cap of Rs. 15,000 and Mr B bought an insurance policy with a room rent capped at 3% of the sum insured. The sum insured of Mr B's health insurance policy is Rs. 5 lakhs. Thus, the room rent cap on Mr B's policy is also Rs. 15,000.`,
        },
        {
          type: `Paragraph`,
          content: `On the other hand, Mr C’s Individual Health insurance policy has a room rent cap of Rs. 2,000 per day during the hospital stay.`,
        },
        {
          type: `Heading`,
          content: `Types of Room Rent Limit In Health Insurance Coverage:`,
        },
        {
          type: `Paragraph`,
          content: `Different health insurance companies have their own rules when it comes to room rent and capping. One thing that is common among all health insurance companies is that the rules that apply to the health policy will be clearly mentioned in the policy document. As a policyholder, you need to make an informed choice while selecting the policy with a specific type of room rent. Here are the common types of room rent capping for your reference:`,
        },
        {
          type: "SmallNumberedContent",
          ordered: true,
          content: [
            {
              title: `No Capping on Room Rent:`,
              para: `Many health insurance policies have no cap on room rent. The policyholders are free to select the room type as per their requirements and comfort.`,
            },
            {
              title: `Co-payment on Room Rent:`,
              para: `Co-payment is sharing the payment made to the hospital for your stay. Co-payment or co-pay on room rent means you as a policyholder will bear the room rent and related expenses together with the insurance company.`,
            },
            {
              title: `Room Rent with Capping:`,
              para: `Insurance companies often put a cap on the amount of room rent a policyholder can claim. Beyond this limit, the insurance company will not bear the related expenses.`,
            },
            {
              title: `Room Rent Cap on Specific Room Types:`,
              para: `The policyholder is given a choice to select a hospital room type as per availability and requirement. If your health insurance policy allows a cap on a certain room type then you have two options. Either, choose a room type that fits inside the room rent limit or bear the additional expenses by selecting a room that costs more than the room rent limit.`,
            },
            {
              title: `Room Rent Waiver Add-on:`,
              para: `As the name suggests, the Room Rent Waiver add-on can be bought with an insurance policy that has room rent capping. But the limit will be waved off under this add-on.`,
            },
          ],
        },
        {
          type: `Heading`,
          content: `How Room Rent Limit Affects Your Overall Health Insurance Claim?`,
        },
        {
          type: `Paragraph`,
          content: `While calculating the claim amount, the insurance company will consider the room rent and applicable capping as the main component. The claim amount will increase or decrease based on the fact that you choose to stay in a room that was under or over the room rent cap. Let's understand how room rent capping will affect your overall claim amount through an example:`,
        },
        {
          type: `SmallHeading`,
          content: `Example Scenario:`,
        },
        {
          type: `Paragraph`,
          content: `Consider Mr John has bought a health insurance policy of Rs. 5 lakhs that has a room rent cap of 1% of the sum insured. After a few years of buying the policy, he had to be hospitalized for Hip Replacement Surgery. His hospital stay was going to be 5-days long, and now he had to choose a room.`,
        },
        {
          type: `Paragraph`,
          content: `His insurance policy allowed him a room that cost Rs. 5,000 per day, however, he chose to stay at one that was worth Rs. 8,000 per day. He did quick math and concluded that the insurance company will bear Rs. 5,000 per day, and he will bear the difference of Rs. 3,000 per day for 5 days.`,
        },
        {
          type: `Table`,
          content: {
            centered: false,
            thead: [`Mr John’s Hospital Bill`, `Rs.`],
            tbody: [
              {
                tData: [`Room Rent Charges`, `Rs. 40,000`],
              },
              {
                tData: [`Cost of Hip Replacement Surgery`, `Rs. 1,75,000`],
              },
              {
                tData: [`Doctor Visits`, `Rs. 30,000`],
              },
              {
                tData: [`Tests`, `Rs. 30,000`],
              },
              {
                tData: [`Medicines`, `Rs. 25,000`],
              },
              {
                tData: [`Total`, `Rs. 3,00,000`],
              },
            ],
          },
        },
        {
          type: `Paragraph`,
          content: `However, the concept of Room Rent does not work as Mr John calculated. It works on the principle of proportionate deductions. It is calculated as the percentage of room rent allowed upon actual room rent.`,
        },
        {
          type: `TableSingle`,
          content: {
            tbody: [
              {
                tData: `Proportionate Deductions = Room Rent Allowed / Actual Room Rent * 100`,
              },
            ],
          },
        },
        {
          type: `Paragraph`,
          content: `The insurance company will pay Mr John’s claim as per the following table:`,
        },
        {
          type: `Table`,
          content: {
            centered: false,
            thead: [``, `Rs.`],
            tbody: [
              {
                tData: [`Room rent allowed`, `Rs. 25,000`],
              },
              {
                tData: [
                  `Cost of Hip Replacement Surgery (62.5%)`,
                  `Rs. 1,09,375`,
                ],
              },
              {
                tData: [`Doctor Visits (62.5%)`, `Rs. 18,750`],
              },
              {
                tData: [`Tests (62.5%)`, `Rs. 18,750`],
              },
              {
                tData: [`Medicines (non-associated expense)`, `Rs. 25,000`],
              },
              {
                tData: [`Claim amount`, `Rs. 19,6875`],
              },
            ],
          },
        },
        {
          type: `Paragraph`,
          content: `Note: Non-associated expenses mean items like medicines as they are sold on MRP. Hence, no deductions. However, based on the room you select, other charges like doctor visits also vary. Due to this, the differential price structure is proportionately deducted.`,
        },
        {
          type: `Paragraph`,
          content: `Since the percentage difference in the room rent limit and the actual room rent is 62.5%, his overall bill will also be affected by 62.5% for applicable items. He has to bear approximately Rs. 1,03,125 from his pocket excluding other deductions.`,
        },
        {
          type: `Heading`,
          content: `The Solution to Room Rent Capping:`,
        },
        {
          type: `Paragraph`,
          content: `There are two scenarios related to your health insurance policy:`,
        },
        {
          type: "SmallNumberedContent",
          ordered: true,
          content: [
            {
              title: `You are already covered under a policy with room rent capping:`,
              para: `In this case, you can consider changing your health insurance plan or switching to a different insurance company altogether. This can be done by porting the current plan to one without any room rent capping. If you want to continue with the current plan, then consider upgrading the sum insured of your health insurance policy. This will increase the limit on room rent capping and give you space to choose a room of your liking without affecting the claim amount much.`,
            },
            {
              title: `You are looking for a new health insurance policy:`,
              para: `Be sure to go through all the documents related to the plan to get clarity on room rent capping. If you don’t find the information on any of the documents, then we recommend you to get in touch with the insurance company and ask them if your plan has this clause.  `,
            },
          ],
        },
        {
          type: `Heading`,
          content: `Conclusion:`,
        },
        {
          type: `Paragraph`,
          content: `The concept behind room rent is not common knowledge and policyholders feel cheated when they receive a low claim amount. This is where the importance of reading the policy document, the fine print, and the terms and conditions is highlighted. Someone who is not familiar with health insurance may have many questions related to things like room rent, co-pay, sub-limits, etc. and the insurance company will readily solve those queries when asked.`,
        },
        {
          type: `Paragraph`,
          content: `ACKO urges you to get your doubts clarified before signing the policy document. In case you receive a lower claim amount, you will know the exact reason behind that claim settlement. Rather you can be prepared for such situations if you are aware of the different concepts of health insurance.`,
        },
      ],
    },
  },
  {
    id: "a4",
    category: `Group Health Insurance`,
    type: "articles",
    img: a4,
    date: `Nov 8,2021`,
    title: `Corporate Health Insurance When Changing Jobs: Things to Consider`,
    article_url: `corporate-health-insurance-when-changing-jobs`,
    mainContent: `The cost of healthcare is on the rise, and it is the primary reason why health insurance is an absolute need for you and your family. Health coverage, especially during the period between changing jobs is crucial since you need health insurance to protect yourself against unforeseen medical emergencies. When the time has come to change jobs, it is essential to understand various options regarding your health insurance coverage. Here are a few tips for making sure you and your family are covered with health insurance when changing jobs.`,
    moreContent: {
      contentData: [
        {
          type: `Heading`,
          content: `Health Insurance When Changing Jobs`,
        },
        {
          type: `Paragraph`,
          content: `As an employee, you may be covered by the employer health insurance (also known as Group Mediclaim Policy or Group Health Insurance Policy), but what happens if the health insurance for employees does not provide coverage after leaving or quitting the job?`,
        },
        {
          type: `Paragraph`,
          content: `Having health insurance when you are changing jobs or when you have been laid off, or when you are becoming self-employed will help protect you when you need medical care, especially during emergencies. Without health insurance cover for you and your family, you may have to pay from your pocket, and you may easily go bankrupt depending on the severity of the medical emergency. So, what can you do to cover a gap in your health insurance coverage? Thankfully, you have a few options.`,
        },
        {
          type: `Heading`,
          content: `How Does Group Health Insurance Work Between Jobs?`,
        },
        {
          type: `Paragraph`,
          content: `Typically, the Group Insurance Scheme provided by your employer ends on the last working day of the employee. However, some companies in the country provide group insurance coverage for employees and pay the premium in full or partially. However, can the group insurance cover be transferred or converted to an individual health insurance policy in case you want to change jobs, or you have been laid off?`,
        },
        {
          type: `Paragraph`,
          content: `The Insurance Regulatory and Development Authority of India (IRDAI) states that an employee can convert the group cover to an individual health insurance plan with the same insurance company after completing the required formalities.`,
        },
        {
          type: `Paragraph`,
          content: `That being said, the insurance provider has the full right to decide on the terms and conditions of the new policy. This option of switching from group insurance to individual insurance is offered only by a few insurance companies and employers. Hence, you need to check with your employer if there is an option to remain with the same insurer, except that it will be converted to an individual insurance plan.`,
        },
        {
          type: `Paragraph`,
          content: `You may have to pay an extra premium and may have to provide a medical certificate to change over from group to individual health insurance. Please note that this process is not mandatory, and it is the insurance company’s decision to offer the conversion or not.`,
        },
        {
          type: `Heading`,
          content: `Review Your Insurance Options When Switching Jobs`,
        },
        {
          type: `Paragraph`,
          content: `There can be two situations. First, you can switch the Group Health Insurance to Individual Insurance. Second, you can buy private health insurance for you and your family. Here are some questions to ask before you quit the current job for a new opportunity:`,
        },
        {
          type: "SmallNumberedContent",
          ordered: false,
          content: [
            `Do you have a personal health insurance plan apart from the group insurance provided by the current employer?`,
            `Does the current group insurance plan provide coverage when you are no longer employed with the respective employer?`,
            `Is your personal health insurance policy coverage sufficient enough to cover you and your family during medical emergencies?`,
            `Will a short-term or long-term health insurance plan help during the period of unemployment?`,
            `Can you be covered under your spouse’s health insurance plan?`,
          ],
        },
        {
          type: `Heading`,
          content: `How to Cover the Gap in Your Health Insurance When Changing Jobs?`,
        },

        {
          type: `Paragraph`,
          content: `Having you and your family covered under the personal Family Health Insurance Policy is important and necessary. But, situations can be different. You may want to take a break before you join the new job, or you are yet to find a new job. The gap between the old and new can be stressful especially in the case of medical emergencies. What can you do to cover the gap in your health insurance plan after you change jobs? Here is how you can cover the gap:`,
        },
        {
          type: `SmallHeading`,
          content: `Find Out When the Current Group Insurance Policy Ends`,
        },
        {
          type: `Paragraph`,
          content: `If you currently have personal health insurance, ensure that you find out when it expires. If it is expiring during the gap, renew the plan to continue to the coverage. As for the current employer health insurance plan, the date may vary depending on the insurer. Verify the details with your HR team to find out how your employer’s health insurance works.`,
        },
        {
          type: `SmallHeading`,
          content: `Find Out For How Long You Will Require the Health Insurance Coverage`,
        },
        {
          type: `Paragraph`,
          content: `After learning about when your existing health insurance policy expires, you will know the timeframe required to cover your health insurance gap. There are short-term and permanent health insurance plans; however, you need to find a plan which suits your needs. These plans can be exclusive in nature since they offer specific coverage. Hence, choose the right plan as per your requirements.`,
        },
        {
          type: `SmallHeading`,
          content: `Compare All the Plans in the Market`,
        },
        {
          type: `Paragraph`,
          content: `In all your major decisions, you need to compare all the plans currently available in the market and how it can provide you with the right coverage. Each type of plan can vary greatly in price and the coverage. Ensure that you completely understand the plans before you make the decision.`,
        },

        {
          type: `Heading`,
          content: `Conclusion`,
        },

        {
          type: `Paragraph`,
          content: `Like all major decisions in life, health coverage for you and your family during medical emergencies or planned hospitalisations is absolutely necessary. You need to have a Health Insurance Plan so that you have a shield against unforeseen medical bills. Consider buying a personal or private health insurance plan along with the employer group plan to stay protected at all times. But, before you do that, ensure that you compare all options in the market to make an informed decision.`,
        },
      ],
    },
  },
  {
    id: "a5",
    category: `Group Health Insurance`,
    type: "articles",
    img: a5,
    date: `Jul 22,2021`,
    title: `A Quick Guide on Group Insurance for Your Employees`,
    article_url: `a-quick-guide-on-group-insurance-for-your-employees`,
    mainContent: `For you, as an employer or a Human Resources executive, your employees are the most important asset for the growth of your organisation. Hence, it is important not to ignore your employee’s health and wellbeing. Nowadays, several people-first organisations are adopting employee-friendly and innovative employee benefits programs, including insuring employees with a comprehensive and inclusive group health policy. This quick guide is designed to give you an overview and help you make an informed choice regarding Employee Health Insurance.`,
    moreContent: {
      contentData: [
        {
          type: `Heading`,
          content: `Group insurance for your employees in an easy way`,
        },
        {
          type: `Paragraph`,
          content: `Employee insurance, when offered the right way, can prove to be productive. To achieve this goal, the Group Insurance Scheme must be employee-centric. Here are eight important points to note while selecting employee-centric employer-provided health insurance.`,
        },
        {
          type: "NumberedContent",
          content: [
            {
              heading: `Know what you want`,
              para: [
                `Whether you are buying a product or a service; knowing what you want makes the decision-making process easier. The same is applicable for purchasing a Group Insurance Policy as well. However, here, you must know what you want as well as what your employees want, as they are the ultimate beneficiaries of the policy. Your priority might be to save cost, but that should not compromise the insurance coverage offered to the employees.`,
                `It is crucial to strike the right balance between the insurance premium payable by you and the insurance features and services offered to your employees. Thus, the insurance plan can be picked mainly based on your employees’ average age, prevalent healthcare costs in the location, and the ease with which the entire Employee Health Insurance process (from onboarding to settling claims) is handled by the insurer. All the offerings must offer value for money as per the charged premium.`,
              ],
            },
            {
              heading: `The fine print is important`,
              para: [
                `All insurance policies come with their sets of inclusions and exclusions, and terms and conditions. It is vital to read the fine print of the Group Health Insurance Plan before buying the policy. This will help you know the policy's exact scope and avoid shocks at the time of claim settlement.`,
                `For instance, some features and benefits of the plan might be a part of the base plan, while some might be available in exchange for additional payment. Details regarding limits (for example, sub-limits, room rent, etc.) and periods (for example, waiting period, grace period, etc.) must be checked as well.`,
              ],
            },
            {
              heading: `Discuss your insurance requirements`,
              para: [
                `Once you have understood your and your employees’ needs, and gone through the fine print, you will have a fair idea about the insurance requirements. Have an open discussion about these requirements with your insurer.`,
                `For example, ACKO’s Group Medical Cover does not follow a one-size-fits-all philosophy. You can pick and choose the coverage; the policy can be tailor-made at a group level as well as at an individual level. You can decide the sum insured at a group level, while an employee can enhance it at a personal level by paying for the extra coverage.`,
              ],
            },
            {
              heading: `Be aware of policy nuances`,
              para: [
                `Insurance is a tool to mitigate financial risks. It cannot remove them completely, nor is it a profit-making venture for the policyholder. Thus, there are some details that both the employer and the employees need to be aware of.`,
                `For instance, the Group Mediclaim Policy will not cover the entire hospital bill. There are particulars that the employee needs to account for. For example, consumables charges, deductibles, copayments (if any), etc. `,
                `Such nuances need to be understood by the employer and the employee to set the right expectations from the Group Health Plan.`,
              ],
            },
            {
              heading: `Understand the legal implications`,
              para: [
                `The Indian government had encouraged the organisations that were opening up after the 2020 COVID-19 lockdown to insure their employees. Also, if your organisation falls under certain types of industries (for example, manufacturing), then you might be required to insure your employees, factory workers, etc., accordingly, as per the Employee State Insurance Act, 1948. Details about Employee State Insurance and Group Medical Cover can be discussed with your legal team.`,
              ],
            },
            {
              heading: `Reactive and proactive health insurance`,
              para: [
                `Corporate Health Insurance Plans have evolved from being merely reactive to being proactive. Reactive insurance simply means offering financial assistance when the employee is hospitalised. Proactive insurance means enabling a lifestyle that leads to avoiding hospitalisation in the first place, along with offering financial assistance.`,
                `Incentivising good health/fitness activities, encouraging health check-ups by offering discounts on lab tests, and presenting avenues for preventive healthcare consultations with professionals (for example, teleconsultations with psychologists) are all part of proactive health insurance for employees.`,
              ],
            },
            {
              heading: `Insurance and employee benefits`,
              para: [
                `You can design your employee benefits program by keeping Group Health Insurance at its core. If you opt for proactive insurance measures mentioned above, then you are already taking the steps towards it.`,
                `Other ways to do so are by offering unlimited and free doctor consultations, teleconsultations with wellness experts regarding diet and mental health, discounts on medicine, etc. These are not futuristic features, they are currently offered via the ACKO Health app.`,
              ],
            },
            {
              heading: `Tech-based health insurance`,
              para: [
                `In 2021, all major sectors have leveraged technology to serve their customers. Insurance, including Group Health Insurance, is not far behind. For example, ACKO’s Group Medical Cover is tech-based and easily accessible via the mobile app. This means paperless insurance, easy claims, and total transparency.`,
              ],
            },
          ],
        },
        {
          type: `Heading`,
          content: `Ways to save on Employee Health Insurance`,
        },
        {
          type: `Paragraph`,
          content: `Here’s how you can save money while offering the Employee Health Scheme.`,
        },
        {
          type: "SmallNumberedContent",
          ordered: false,
          content: [
            `Customise your plan to include only the required coverage.`,
            `Offer adequate coverage as the base sum insured and give the employees the option to enhance their cover individually.`,
            `Stick with the same insurer to receive a policy renewal discount, especially if the percentage of claims raised during the policy period is on the lower side.`,
            `Choose a tech-based insurer to reduce operational costs.`,
            `Receive tax rebates for the premium paid as per the provisions of the Income Tax Act.`,
          ],
        },
        {
          type: `Heading`,
          content: `Other things to know while offering employee health insurance`,
        },
        {
          type: `Paragraph`,
          content: `Here’s a secondary checklist to consider apart from the above-mentioned primary one with regards to Employer-employee Insurance.`,
        },
        {
          type: "NumberedContent",
          content: [
            {
              heading: `Premium Payment`,
              para: [
                `In most cases, the premium to insure the employees is paid entirely by the employer. But there can be instances where the premium is shared. However, it is not advisable to burden your employees with premium payment as Group health Insurance is often considered as an employment benefit.`,
              ],
            },
            {
              heading: `Switching insurers`,
              para: [
                `In most cases, the premium to insure the employees is paid entirely by the employer. But there can be instances where the premium is shared. However, it is not advisable to burden your employees with premium payment as Group health Insurance is often considered as an employment benefit.`,
              ],
            },
            {
              heading: `Avoid admin hassles`,
              para: [
                `Insuring your employees with a comprehensive health insurance cover should not be an additional hassle for your HR/admin team. Ensure this does not happen by picking a digital-first insurer. For example, you can avoid admin hassles with ACKO’s Group Medical Cover, as it offers easy self-serve enrollment via the mobile app.`,
              ],
            },
          ],
        },
        {
          type: `Heading`,
          content: `Where to find health insurance plans for employees?`,
        },
        {
          type: `Paragraph`,
          content: `You can find health insurance plans for your employees by seeking recommendations from your peers or browsing online for a suitable plan. Or else, you can skip all this and end your search with ACKO. ACKO’s Group Medical Cover caters to not only those employees who raise claims during the policy period (on an average 10% of employees) but even to those that do not raise a claim (the remaining 90%).`,
        },
        {
          type: `Paragraph`,
          content: `With curated health benefits for your employees, a wide network of hospitals, labs, and doctors, and a one-stop app for everything related to insurance, ACKO’s Group Medical Cover is a modern plan for people-first organisations.`,
        },
      ],
    },
  },
  {
    id: "a6",
    category: `Two Wheeler Insurance`,
    type: "articles",
    img: a6,
    date: `Nov 17,2021`,
    title: `Basic Mistakes to Avoid When Renewing Two Wheeler Insurance Online`,
    article_url: `mistakes-to-avoid-when-renewing-two-wheeler-insurance-online`,
    mainContent: `Typically, when you buy a new bike/scooter, the dealer might provide you with a standard two-wheeler insurance policy with a tenure of one year. After one year, you need to renew the plan, and renewing the policy through the traditional method (offline) can be a daunting task for someone who is doing it for the first time. Hence, the easiest way to do it is by renewing the policy online via digital-first insurers such as ACKO. In this article, let’s discuss the basic mistakes to avoid when renewing two-wheeler insurance online.`,
    moreContent: {
      contentData: [
        {
          type: `Heading`,
          content: `Common Mistakes to Avoid When You Renew Bike Insurance Online`,
        },
        {
          type: `Paragraph`,
          content: `Renewing two-wheeler insurance online is an easy process, and it hardly takes a few minutes to get your bike insurance policy renewed from ACKO. All you need is to provide the details of your two-wheeler and the previous policy. But without proper knowledge about the fundamentals of the bike insurance policy, you may commit some common mistakes while renewing the policy online. Below are some of the common mistakes you should avoid when renewing a two-wheeler insurance plan online.`,
        },
        {
          type: "SmallNumberedContent",
          ordered: false,
          content: [
            {
              title: `Not Availing your NCB Discount:`,
              para: `NCB or No Claim Bonus for bike is the discount rewarded by ACKO (insurer) during the renewal process, provided you have not raised any claims during the previous policy period. You can claim the NCB discount by renewing the policy within 90 days of the policy expiry. But one of the common mistakes you make is to renew the policy after it has expired for an extended period. After 90 days of policy expiry, you will lose the NCB discount accumulated over the years. So, it is better to renew the two-wheeler insurance plan within the expiry date to avail of the NCB discount and ensure seamless coverage for your two-wheeler.`,
            },
            {
              title: `Not Opting for a Multi-year Plan:`,
              para: `One of the most common mistakes while renewing the bike insurance plan is not opting for a multi-year insurance policy. Yes, ACKO offers two and three-year insurance plans, and by buying these plans, you can save on the premium. It doesn’t matter if you are renewing a Third party bike insurance or Comprehensive Policy; multi-year plans are beneficial as you can save money and need not worry about the yearly renewal of the policy.`,
            },
            {
              title: `Not Choosing the Maximum IDV:`,
              para: `ACKO allows you to customise the bike's IDV (Insured Declared Value) as per your needs when renewing the Comprehensive Policy. IDV is the approximate market value of the vehicle.The premium may increase by opting for a higher IDV, but it is worth the money as it provides maximum coverage.`,
            },
            {
              title: `Not Assessing Your Add-on Requirements:`,
              para: `A Comprehensive Policy comes with a host of add-ons to enhance the policy benefits. But while renewing the policy, you often ignore them, citing that add-ons will increase the premium. But in reality, add-ons may be helpful and save you from a financial crisis. For instance, if your bike’s engine is damaged, the Engine Protect add-on will cover the loss. So, assess your requirements before renewing the policy.`,
            },
            {
              title: `Not Buying Personal Accident Cover:`,
              para: `A Personal Accident (PA) Cover is a must in India to comply with the rules and regulations. The PA Cover provides coverage worth Rs. 15 lakhs if the rider suffers disability (temporary/permanent) or accidental death. So, do not ignore the PA Cover while renewing the bike insurance policy. You need to have only one Personal Accident Cover if you own multiple vehicles.`,
            },
            {
              title: `Not Providing Details About Modifications:`,
              para: `You need to intimate ACKO during the renewal process if you have done any modifications to your two-wheeler. You have to provide details about the modified parts so that there are no hassles during the claim. If you fail to inform about modifications, your claim may be rejected, or you may receive a reduced claim amount.`,
            },
            {
              title: `Filling Out Incorrect Information:`,
              para: `One of the most common mistakes you can easily avoid is filling incorrect information during the renewal process. You need to be careful when providing details such as vehicle registration number, previous policy details and year of purchase. If these details are found to be incorrect, the policy may be invalid. So, ensure that you provide the correct information while renewing the two-wheeler insurance plan.`,
            },
            {
              title: `Not Renewing the Policy Before Expiry:`,
              para: `Never let your bike insurance policy expire, as it will leave you with no coverage for your two-wheeler. In case of a mishap during that period, it will lead to a significant financial loss. Also, you may lose out on the NCB benefits if you do not renew the policy within 90 days of expiry. So, ensure that you renew the policy before it expires.`,
            },
          ],
        },
        {
          type: `Heading`,
          content: `Conclusion`,
        },
        {
          type: `Paragraph`,
          content: `Renewing two-wheeler insurance online is a straightforward process. But without proper knowledge or performing thorough research, you may end up making some of the mistakes mentioned in this article. So, be informed while renewing the policy and avoid the mistakes discussed in this article.`,
        },
        {
          type: `Paragraph`,
          content: `At ACKO, you can renew the bike insurance plan online within a few minutes via the website (www.acko.com) or mobile app. There is no paperwork or documentation. And if you have any queries regarding the bike insurance renewal, you can get in touch with ACKO's two-wheeler insurance experts via email (hello@acko.com) or give us a call at 18002662256.`,
        },
      ],
    },
  },
  {
    id: "a7",
    category: `Health Insurance`,
    type: "articles",
    img: a7,
    date: `Apr 7,2021`,
    title: `Difference Between Network Hospitals & Non-network Hospitals`,
    article_url: `difference-between-network-and-non-network-hospitals`,
    mainContent: `With the advancement in the medical infrastructure, health care costs have also been on an upward trajectory, especially in metro cities. With the rising costs, access to good healthcare facilities and treatments at affordable costs has become challenging. This is especially true for the mid-income and lower-income groups.
    <br/><br/>
    However, thanks to health policies, medical treatment has become easier and simpler! For example, with health insurance, you can safeguard yourself from rising medical costs in case of hospitalisation. Plus, you can still opt for the best treatment without worrying too much about the expenses. In fact, things get easier and hassle-free if you have availed of the cashless facility at network hospitals.
    <br/><br/>
    In this article, let us decode the terms network and non-network hospitals for you.`,
    moreContent: {
      contentData: [
        {
          type: `Heading`,
          content: `What are Network and Non-network Hospitals?`,
        },
        {
          type: `Paragraph`,
          content: `To set a backdrop, sometimes hospitals may levy higher charges to patients with a medical insurance policy than patients without a health policy. Hence, insurance companies partner with selected hospitals and negotiate costs to reduce their indemnity costs. Not just this, this also helps insurers offer seamless claims experience to their customers when they partner with hospitals. The results are faster claim settlement and improved customer satisfaction.`,
        },
        {
          type: `Paragraph`,
          content: `This arrangement also works in favour of network hospitals since they get more patients through the network of the health insurance companies. Hence, all the hospitals associated with health insurance companies are called network hospitals. On the other hand, all the hospitals outside this network or with whom health insurance companies do not have any association are called non-network hospitals.`,
        },
        {
          type: `Heading`,
          content: `Understanding How Network and Non-network Hospitals Work`,
        },
        {
          type: `Paragraph`,
          content: `Having understood the basic definition of network and non-network hospitals, let us look at how it works and the role of a cashless facility. For that, let us take a few examples. `,
        },
        {
          type: `ParagraphTitled`,
          isArray: false,
          content: {
            title: `Scenario 1 : `,
            para: `Mr. Mehta gets sick and needs to be hospitalised. He has availed of the cashless facility from his insurance company. He observes that one of the network hospitals is in proximity and offers the treatment suggested by medical practitioners. He gets hospitalised in one of the network hospitals and Mr. Mehta/his family member gets in touch with the Third-party Administrator (TPA) desk at the hospital. To simplify things, TPA acts as intermediaries between policyholders and insurance providers and plays a vital role in the smooth processing of health insurance claims.`,
          },
        },
        {
          type: `Paragraph`,
          content: `Coming back to the example, Mr. Mehta’s family member then completes a quick documentation work, i.e., form-filling to avail of the cashless hospitalisation benefit. Once it is approved, Mr. Mehta can start the treatment, and the insurance company will bear all the expenses related to the hospital. Mr. Mehta only pays the deductible amount as per his policy document. Here, Mr. Mehta does not have to submit any bills/invoices to the insurance company. Also, there is no waiting period. Meaning, as soon as you share your health policy details, the hospital will immediately verify it. Once confirmed, all the hospitalisation expenses will be covered.`,
        },
        {
          content: `However, it is important to note that only his hospitalisation expenses would be covered. He may still have to claim reimbursement from his insurance company for medical expenses as per the terms and conditions.`,
          type: `Paragraph`,
        },
        {
          type: `ParagraphTitled`,
          isArray: false,
          content: {
            title: `Scenario 2 : `,
            para: `However, there is also a possibility that Mr. Mehta gets admitted to a network hospital but has not availed of the cashless benefit. In this case, Mr. Mehta needs to undergo treatment, get discharged, and claim reimbursement of the medical expenses. To claim reimbursement, he must follow a long and tedious process. First, he will collate all the bills and relevant documents and then share them with the insurance provider.`,
          },
        },
        {
          type: `Paragraph`,
          content: `The insurance provider will evaluate his claim, assess the documents, and settle the claim as per the terms and conditions. The entire process may take a longer time to complete. However, not just time; in this case, Mr. Mehta also needs to arrange the funds for the treatment. This can become more stressful in scenarios where medical expenses are high.`,
        },
        {
          type: `ParagraphTitled`,
          isArray: false,
          content: {
            title: `Scenario 3 : `,
            para: `Mr. Mehta gets admitted to a non-network hospital. This may be because of the unavailability of the treatment in a nearby network hospital or an emergency. In this case, it does not matter if he has availed of the cashless facility or not. The process would remain the same as Scenario 2. He will get the treatment, pay the bills, get discharged, and then claim reimbursement.`,
          },
        },
        {
          type: `Paragraph`,
          content: `In Scenario 2 and Scenario 3, the process is tedious, Mr. Mehta must arrange the funds, and it takes a longer time to settle the claims. Also, suppose the insurance company finds out the expenses are much higher than the standard/average expenses. In that case, it may partially settle a claim or even reject it based on the terms and conditions of the policy.`,
        },
        {
          type: `Heading`,
          content: `Network vs Non-Network Hospitals`,
        },
        {
          type: `Paragraph`,
          content: `Here is a tabular representation of the classification between network and non-network hospitals.`,
        },
        {
          type: `Table`,
          content: {
            centered: true,
            thead: [
              `Parameter`,
              `Network hospital with cashless facility	`,
              `Network hospital without cashless facility	`,
              `Non-network Hospital`,
            ],
            tbody: [
              {
                tData: [
                  `Definition`,
                  `The policyholder gets admitted to a partner hospital and has availed of the cashless benefit.`,
                  `The policyholder gets admitted to a partner hospital but has not availed of the cashless benefit.`,
                  `The policyholder gets admitted to a non-partner hospital.`,
                ],
              },
              {
                tData: [
                  `Waiting period`,
                  `No. Once approved, the insurance company will settle the bill immediately.`,
                  `Yes. Generally, there will be a waiting period of 10-12 days (which may vary with the insurer) between raising and receiving the claim amount.`,
                  `Yes. Generally, there will be a waiting period of 10-12 days (which may vary with the insurer) between raising and receiving the claim amount.`,
                ],
              },
              {
                tData: [
                  `Features`,
                  `Settlement is quick, The policyholder does not have to arrange funds, Comparatively hassle-free`,
                  `Settlement takes time, The policyholder must arrange funds It is a tedious and long process`,
                  `Settlement takes time, The policyholder must arrange funds It is a tedious and long process.`,
                ],
              },
            ],
          },
        },
        {
          type: `SmallHeading`,
          content: `Words of Wisdom`,
        },
        {
          type: `SmallNumberedContent`,
          ordered: false,
          content: [
            `It is recommended to opt for an insurance company that has a wide network of hospitals. For example, ACKO has partnered with more than 6,500 hospitals across the country to make quality healthcare accessible.`,
            `Once you are sure about the network hospitals in your vicinity, do make a list of them for emergency hospitalisation.`,
            `In case of planned hospitalisation, you may consider getting in touch with TPA to understand the approval process and avoid the last-minute rush.`,
          ],
        },
        {
          type: `Paragraph`,
          content: `Having a health insurance policy with a cashless facility is very important to guard your finances at the time of medical emergencies. Without this facility, you may have to undergo a long and tedious process of arranging funds, paying bills, collecting invoices, and sharing with your insurer for reimbursement. Definitely, a time-consuming process and tedious efforts. `,
        },
      ],
    },
  },
  {
    id: "a8",
    category: `Car Insurance`,
    type: "articles",
    img: a8,
    date: `Apr 27,2022`,
    title: `Car Insurance Online Vs Offline: Which is Better?`,
    article_url: `online-vs-offline-which-is-better`,
    mainContent: `A decade ago, people used to browse online and buy offline. Traditionally, people liked to buy gadgets and clothes offline as they could get the feel of it before buying. But as technology developed and delivering products became faster and cheaper, people started buying online as well. With the combination of smartphones, internet banking, tech-savvy sellers and buyers, one-day delivery, and festive offers, online scored over offline in almost all products and services categories. But what about <a href="/two-wheeler-insurance">car insurance online?</a> Which is better, online car insurance or offline? Read ahead for the answers.`,
    moreContent: {
      contentData: [
        {
          type: `Heading`,
          content: `Difference Between Online Car Insurance Vs Offline Car Insurance`,
        },
        {
          type: `Paragraph`,
          content: `The following table will highlight prominent differences between buying car insurance via the online method and the offline method. By going through the table, you will be able to gauge the best fit for you as per your needs.`,
        },
        {
          type: `Table`,
          content: {
            centered: false,
            thead: [`Points`, `Offline Car Insurance`, `Online Car Insurance`],
            tbody: [
              {
                tData: [
                  `1) Meaning`,
                  `Offline car insurance is a purchase process where the act of buying a policy takes place at physical office space or by meeting an insurance agent. For example, an insurance company’s office or a car dealer’s office who has a tie-up with an insurer.`,
                  `Online car insurance is a purchase process where the act of buying a policy takes place in a virtual setting like a website or a mobile application.`,
                ],
              },
              {
                tData: [
                  `2) Process`,
                  `Here, the process involves meeting the seller, filling forms, and submitting the required papers.`,
                  `Here, the process involves visiting the insurer’s website/app, sharing basic details, choosing the plan, and buying the same by making the payment online.`,
                ],
              },
              {
                tData: [
                  `3) Transparency`,
                  `There’s less transparency in this method as there is an intermediary involved.`,
                  `There’s more transparency in this method as there is no intermediary. You can access all documents on the website, read through them, and make an informed choice.`,
                ],
              },
              {
                tData: [
                  `4) Time Factor`,
                  `Comparatively, this is a lengthy process. Starting from setting up a meeting with the seller, to submitting documents and making the payment can take up a few days.`,
                  `Buying a car insurance policy online is a quick process. It does not require any appointments. You can insure your car any time of the day as per your convenience. Unlike a physical office, the online platform like a website does not have an end-of-the-day closing time.`,
                ],
              },
              {
                tData: [
                  `5) Payable Premium`,
                  `The payable premium in a traditional office-based insurance process can be higher in comparison to the online method. This can be attributed to higher company overheads.`,
                  `As online insurers do not have a lot of infrastructures to look after, their operational cost is on the lower side. No intermediaries mean no commissions and that in many cases translates into low-cost insurance plans.`,
                ],
              },
              {
                tData: [
                  `6) Influencing`,
                  `The chances of being influenced by an agent or an intermediary into making a particular decision are more in the offline process.`,
                  `The chances of being influenced are less here as you are in control throughout the decision-making process.`,
                ],
              },
              {
                tData: [
                  `7) Comparison`,
                  `It is tough to compare policies offline. You will have to visit multiple people. Even if one agent is presenting to you several options, it is time-consuming and challenging to compare brochures.`,
                  `Comparing car insurance policies online is not at all challenging. You can either pick an aggregator website and get the majority of the quotes and coverages in one shot. Or else, you can visit the websites of your preferred insurers and then use the premium calculator to know the quote, and then compare them.`,
                ],
              },
              {
                tData: [
                  `8) Customer Support`,
                  `Often, you have to rely on the agent/intermediary for support while buying the policy offline. If the insurance company has a calling-based support team, you can seek help there as well.`,
                  `In the online process, you can seek answers to your queries thanks to website content, blog posts, and chatbots. There are dedicated teams that handle email and call-based queries as well.`,
                ],
              },
              {
                tData: [
                  `9) Claim Settlement`,
                  `As the focus is on manual-processes, the claim settlement process can be a lengthy one.`,
                  `Online car insurers offer a quick and hassle-free claim settlement process. They can do so because of the tech-based infrastructure.`,
                ],
              },
              {
                tData: [
                  `10) Renewal`,
                  `The offline renewal process poses similar challenges faced during the offline policy buying process.`,
                  `The online renewal process is even easier than the online buying process. Assuming you are renewing from the same insurer from whom you purchased the plan, your data will be saved by the insurer. All you have to do is log in to the website and make the payment. The policy shall be renewed as soon as the payment goes through, which happens almost instantly.`,
                ],
              },
            ],
          },
        },
        {
          type: `Heading`,
          content: `Benefits of Buying Online Car Insurance:`,
        },
        {
          type: `Paragraph`,
          content: `By going through the above-mentioned table, you must have concluded that in most cases, buying car insurance online is beneficial than buying it offline. If you are still confused, here are some direct benefits of buying online car insurance.`,
        },
        {
          type: `NumberedContent`,
          content: [
            {
              heading: `Better Research`,
              para: [
                `You can find out all the details about a car insurance policy by researching online. There’s the insurer’s website, blog posts, and the Policy Wordings as well. The online policy buying process aids better research and comparison so that you can make an informed and calculated decision.`,
              ],
            },
            {
              heading: `Low Premium`,
              para: [
                `Generally, car insurance policies offered by digital-first insurers are less expensive than those offered by offline insurers. This is because the online insurers have a low operational cost and less or no dependency on intermediaries, thereby reducing the cost paid as commissions.`,
              ],
            },
            {
              heading: `2-minute Purchase`,
              para: [
                `It is possible to buy a car insurance policy in two minutes via an app or a website. No paperwork. No money paid as commissions. No filling long forms. No submitting a bunch of documents. Online car insurance is quick, simple, and efficient.`,
              ],
            },
            {
              heading: `Prompt Service`,
              para: [
                `If you are stuck while buying the policy or while raising a claim or simply want to rectify an error in the policy document, the online insurer’s customer support team is at your service 24×7.`,
              ],
            },
            {
              heading: `Hurdle-free Claim Settlement`,
              para: [
                `Online car insurance eliminates hurdles to claim settlement such as heavy documentation, coordination problems, and money transfer. The online insurers offer instant claim settlement, Cashless Claims, and seamless coordination thanks to Blockchain, Artificial Intelligence, and Machine Learning.`,
              ],
            },
          ],
        },
        {
          type: `Heading`,
          content: `What is offline car insurance?`,
        },
        {
          type: `Paragraph`,
          content: `Offline car insurance simply refers to buying car insurance by personally visiting the insurance company or through an insurance agent. It involves submitting physical paperwork and signing documents. When you receive your car insurance policy, you must keep it safe as there is a chance that you might lose this document. If you lose it, you may have to pay traffic fines as you need to produce the document when asked to do so by traffic police.`,
        },
        {
          type: `Heading`,
          content: `Things That Can Go Wrong When Buying Car Insurance Offline`,
        },
        {
          type: `Paragraph`,
          content: `On a technological front, India is progressing at a faster rate now as compared to a few decades ago. The Internet has a huge role to play in this growth. For example, buying car insurance online is way more convenient than buying the same policy offline. But If you are convinced that offline insurance is better, then let us help you with some of its downsides. Following is the list of 5 things that can go wrong while buying car insurance offline.`,
        },
        {
          type: `NumberedContent`,
          content: [
            {
              heading: `You could pay more`,
              para: [
                `There are a lot of operational costs involved when you buy a car insurance policy offline. Plus, if you take the help of an insurance agent, then the cost of your policy increases further. All this leads to an expensive policy. It is not guaranteed that you get value for money in exchange for the coverage you receive.`,
              ],
            },
            {
              heading: `No option to compare car insurance plans`,
              para: [
                `Your car insurance agent will provide a brochure from the insurance company. It contains various details of the plan, and the insurance agent will give a quote for your policy. But there is no easy option available for comparing plans from different insurance companies and knowing what other plans on the market are offering. Buying car insurance without comparing plans can lead to an over-priced policy with fewer benefits. `,
              ],
            },
            {
              heading: `You need to depend on an insurance agent`,
              para: [
                `Some car owners may not be aware of the nitty-gritty of a car insurance policy, and the best bet here is hiring an insurance agent. But doing so increases your dependency on them. Is this a bad thing? Well, it depends on how good your insurance agent is. Some will guide you to get the best coverage, while others may insist on getting the coverage you may not require.`,
              ],
            },
            {
              heading: `No solid way of checking the insurer's reputation`,
              para: [
                `While buying car insurance offline, you mostly depend on word-of-mouth to know how good (or bad) a car insurance company is. Unlike offline insurance, buying insurance online allows you to check reviews and star ratings from existing customers. Thus, you understand how good your future insurance company is.`,
              ],
            },
            {
              heading: `Offline car insurance is a time-consuming process`,
              para: [
                `Buying car insurance offline requires an investment of time along with your money. The process begins with you getting in touch with an insurance agent and setting up a meeting. Then you fill the proposal form and attach documents to apply for a policy. Next comes the approval, and finally, a policy is generated. Here you receive the physical copy of the document via mail. `,
                `The entire process can easily take around 7 to 10 working days. If your previous policy expires between this period, you are left uninsured and exposed to financial losses if you decide to drive the car.`,
              ],
            },
          ],
        },
        {
          type: `Heading`,
          content: `What is the solution to offline car insurance?`,
        },
        {
          type: `Paragraph`,
          content: `Buying car insurance through a digital insurance company is a solution to all the issues you face while buying a plan offline. Online car insurance policies are cheaper as the operational costs related to issuing a physical car insurance policy are eliminated. If you choose ACKO, you don’t have to bear the additional costs of hiring an insurance agent as well. Thus, you get a solid discount on your ACKO car insurance policy.`,
        },
        {
          type: `Heading`,
          content: `Which is Better?`,
        },
        {
          type: `Paragraph`,
          content: `The points mentioned in the previous sections state that online car insurance is better than offline car insurance. However, you must look at these options from your own perspective. Someone who is not tech-savvy, is too comfortable with the agent-based approach, and does not mind foregoing the online-based benefits might prefer the traditional way.`,
        },

        {
          type: `Paragraph`,
          content: `There is a way around this as well. If you feel the online process is daunting, simply ask a millennial relative to help. Better, you can try to insure your car online yourself, it is not difficult at all. The final call is yours. If you feel a method is stressful for you, skip it and pick the other one. But make sure to buy and renew car insurance as it is a legal requirement.`,
        },
        {
          type: `Heading`,
          content: `Why trust ACKO?`,
        },
        {
          type: `Paragraph`,
          content: `Take a look at the following to understand why placing your trust in ACKO for buying car insurance is a great idea.`,
        },
        {
          type: "SmallNumberedContent",
          ordered: true,
          content: [
            `ACKO is an IRDA licensed general insurance company. Our registration number is 157.`,
            `You get great discounts due to digital infrastructure.`,
            `We offer an option for instant claim settlement for minor damages`,
            `6.2 crore people are our customers already`,
            `We have a stellar rating of 5 stars on more than 95% of our reviews on Facebook and Google.`,
          ],
        },
      ],
    },
  },
  {
    id: "a9",
    category: `Group Health Insurance`,
    type: "articles",
    img: a9,
    date: `Nov 8,2021`,
    title: `What Is Group Health Insurance Plan And How Does It Work?`,
    article_url: `what-is-group-health-insurance-plan-and-how-does-it-work`,
    mainContent: `One would be familiar with the logic that buying a product in bulk provides benefits as compared to buying a single item. If one enforces this logic with respect to health insurance, the resulting product would be called <a href="/group-health-insurance">Group Health Insurance.</a> In this article, let’s shed some light on what exactly is a Group health insurance policy and how does it work.`,
    primContent: `As the same suggests, a Group Health Insurance policy also called as Group Mediclaim policy is a health insurance policy that covers a group of people. These people in one “group” can be related in any manner. They can either be employees working in the same organization, people living in one area, relatives, friends, etc. However, Group Mediclaim policy is usually bought by employers to financially secure their employees in case of a medical emergency.`,
    moreContent: {
      contentData: [
        {
          type: `Heading`,
          content: `Features and Benefits of the Group Insurance Policy:`,
        },
        {
          type: `Paragraph`,
          content: `Group health insurance plans are beneficial for both – employers and employees. These plans provide a financial backup that can be used in case of hospitalization. Here are some of the features and benefits of the plan:`,
        },
        {
          type: `SmallNumberedContent`,
          ordered: false,
          content: [
            {
              title: `Pre- and post-hospitalization: `,
              para: `The coverage depends upon the illness suffered by the insured. Pre-hospitalization expenses for 30 days are covered, i.e. expenses of treatment before getting hospitalized are covered. Also, Post-hospitalization is covered for 60 days after the date of discharge may be covered under the plan.`,
            },
            {
              title: `Hospitalization: `,
              para: `Depending on the terms of your health insurance company, the group health insurance plan may provide coverage for hospital accommodation i.e. room charges, doctor visits, specialists fees, nursing charges, etc.`,
            },
            {
              title: `Nominees: `,
              para: `The scope of a Group Health insurance plan extends not only to a group of individuals but also upon the dependents of that individual. Thus, instead of buying a separate cover for each member of a family, they are covered under the plan offered by an employer of one member of the family.`,
            },
            {
              title: `Domiciliary Hospitalization: `,
              para: `Sometimes, an insured person is unable to get admitted to a hospital and instead opts for medical treatment at home. This is called Domiciliary Hospitalization. This may be covered under Group Health insurance.`,
            },
            {
              title: `Day Care Procedures: `,
              para: `To avail the coverage of a health insurance plan, it is usually necessary to be hospitalized for at least 24 hours. Your insurer may cover you for daycare procedures that do not require 24-hour hospitalization.`,
            },
            {
              title: `Cashless Hospitalization: `,
              para: `Some insurers have a wide network of hospitals. If you are hospitalized in one of such network hospitals, you can avail of cashless treatments. Here you do not have to keep a track of the medical bills and other documents to claim insurance. In fact, apart from the amount not covered, all other bills are settled directly between the insurance company and the hospital.`,
            },
          ],
        },
        {
          type: `SmallHeading`,
          content: `Group Plan Vs. Individual Plan`,
        },
        {
          type: `Paragraph`,
          content: `Here are some key differences between Individual and Group Health Insurance:`,
        },
        {
          type: "Table",
          content: {
            centered: false,
            thead: [
              `Group Health Insurance	`,
              `Individual Health Insurance
            `,
            ],
            tbody: [
              {
                tData: [
                  `Usually bought by an employer	`,
                  `Bought by an individual
                `,
                ],
              },
              {
                tData: [
                  `Medical Checkup may not be required	`,
                  `Medical checkups may be required`,
                ],
              },
              {
                tData: [
                  `Costs less as compared to individual health insurance plans`,
                  `Costs more as compared to group health insurance plans`,
                ],
              },
              {
                tData: [
                  `Coverage cannot be customized as per specific needs`,
                  `Coverage can be customized as per specific needs`,
                ],
              },
            ],
          },
        },
        {
          type: `SmallHeading`,
          content: `Exclusions of Group Health Plan`,
        },
        {
          type: `Paragraph`,
          content: `Below are the conditions under which your health insurance company will not accept a claim. Usually, the exclusions of a group health insurance plan are as follows:`,
        },
      ],
    },
  },
  {
    id: "a10",
    category: `Car Insurance`,
    type: "articles",
    img: a10,
    date: `Nov 15,2021`,
    title: `Cashless Car Insurance Policy - Need of The Hour`,
    article_url: `cashless`,
    mainContent: `For new car buyers, the car insurance aspect of the policy is usually handled by the vehicle dealer. Thereafter, they only think about car insurance either at the time of policy renewal or in the event of a claim. The policy can be renewed via the car dealer but a claim can only be settled by the insurance company. Thus, it is important to know about the claim settlement process. This article is about the steps to claim cashless car insurance in India.`,
    moreContent: {
      contentData: [
        {
          type: `Paragraph`,
          content: `Car insurance companies work hard to make the car insurance process extremely convenient for policyholders. They try to make all the processes associated with car insurance super simple. When it comes to claim settlements, you as a Comprehensive Car Insurance policyholder have two options: Reimbursement Claim Process and the Cashless Claim Process. The following sections will help you understand the Cashless Process and the steps to claim cashless car insurance in India.`,
        },
        {
          type: `Heading`,
          content: `What is the Cashless Claims Process?`,
        },
        {
          type: `Paragraph`,
          content: `A Cashless Claim is a type of claim where the garage and the hospital settle most of the bill among themselves provided you meet the terms and conditions. All you must account for is the depreciation cost, the deductibles cost, and any other repair cost that is not covered by the policy. A noteworthy advantage of this type of process is that if the repair amount is huge, you do not need to arrange for it immediately, which is the case in the Reimbursement Process. More on that later.`,
        },
        {
          type: `Paragraph`,
          content: `A Cashless Claim is possible because of the tie-ups between insurance companies and the garages. The garages that have a tie-up with insurers regarding cashless claim settlements are termed as Network Garages. As the garage and the insurer have a tie-up, the process between the two is streamlined and usually, the claim gets settled quickly and smoothly.`,
        },
        {
          type: `Heading`,
          content: `How to Claim Cashless Car Insurance in India?`,
        },
        {
          type: `Paragraph`,
          content: `To raise a cashless car insurance claim in India, you need to inform the insurance company about the accident or the damage instantly. If it is an accident case and the accident is a massive one, they will send their surveyor on the spot. If not, then they might ask you to take the vehicle to a network garage or they might tow it themselves. This depends upon the insurer. In this case, the surveyor will have a look at the vehicle at the garage.`,
        },
        {
          type: `Paragraph`,
          content: `Once the surveyor ascertains the damage and discusses it with the garage, the repair work will begin and you will be notified about the approximate bill and the insurance coverage amount. The insurer will cover the expenses as per the inclusions and the terms and conditions of the policy. The balance amount needs to be settled by you. This balance amount is marginal as compared to the entire bill amount.`,
        },
        {
          type: `SmallHeading`,
          content: `How Does Cashless Claim Process Work?`,
        },
        {
          type: `Paragraph`,
          content: `The cashless car insurance process works on trust, coordination, and professionalism. There needs to be shared trust between the policyholder, the garage, and the insurer. All parties need to coordinate effectively and act professionally.`,
        },
        {
          type: `Paragraph`,
          content: `The Cashless Claims process works based on the tie-up between the garage and the insurer. In some cases, there might not be an official tie-up, but even then, the insurer might coordinate with the garage and settle the claim in a cashless manner for the policyholder’s convenience. Some insurers have a list of network garages while Acko has almost all as Cashless Garages.`,
        },
        {
          type: `Heading`,
          content: `Steps to Claim Cashless Car Insurance:`,
        },
        {
          type: `Paragraph`,
          content: `The exact process to claim cashless car insurance might differ from one car insurance company to another. There might be subtle changes in the process based on the insurer’s tech support and overall strategy. Here’s an overview of the cashless car insurance in a stepwise manner.`,
        },
        {
          type: `ParagraphTitled`,
          isArray: true,
          content: [
            {
              title: `Step 1: `,
              para: `Contact your insurance company either by calling them or sending an email. Nowadays, some insurers have a dedicated section on their website/app to initiate a claim process. For example, Acko Login.`,
            },
            {
              title: `Step 2: `,
              para: `Share the details about the car damage.`,
            },
            {
              title: `Step 3: `,
              para: `Follow the stated process. For example, in case of a theft, you might be asked to file a First Information Report and share other supporting documents.`,
            },
            {
              title: `Step 4: `,
              para: `For accident claims, the surveyor might visit the accident spot. Otherwise, the car needs to be taken to the network garage and the surveyor will have a look at the damages there.`,
            },
            {
              title: `Step 5: `,
              para: `The surveyor and the mechanic will discuss and let you know the repair cost and the amount covered by the policy based on the coverage and the applicable terms and conditions.`,
            },
            {
              title: `Step 6: `,
              para: `The car will be repaired and the bill will be settled between the garage and the car insurance company. The balance (deductibles) amount needs to be paid by you to the garage.`,
            },
            {
              title: `Step 7: `,
              para: `Contact your insurance company either by calling them or sending an email. Nowadays, some insurers have a dedicated section on their website/app to initiate a claim process. For example, Acko Login.`,
            },
            {
              title: `Step 1: `,
              para: `Contact your insurance company either by calling them or sending an email. Nowadays, some insurers have a dedicated section on their website/app to initiate a claim process. For example, Acko Login.`,
            },
          ],
        },
        {
          type: `Paragraph`,
          content: `Note: In some cases, the towing of the vehicle to the garage and the delivery of the repaired vehicle is performed by the car insurance company.`,
        },
        {
          type: `Heading`,
          content: `Mandatory Documents While Registering for Your Car Insurance Claim:`,
        },
        {
          type: `Paragraph`,
          content: `Nowadays, digital-first insurers do not ask for a list of documents. They are not in favour of form-filling either. However, there might be instances where you may have to scan some documents and share them with them along with the damaged car’s photograph. They might also ask for a video of the damaged car. Some traditional insurance companies still rely on form-filling and ask for a list of documents to be submitted while registering a car insurance claim. The following list will give you an idea about these documents. Note that the requirements may vary from one insurer to another.`,
        },
        {
          type: `SmallNumberedContent`,
          ordered: false,
          content: [
            `Car insurance policy.`,
            `Driving License.`,
            `Registration Certificate.`,
            `First Information Report from the police (for accidents).`,
            `Cancelled cheque.`,
            `Policyholder’s identity proof. For example, Aadhaar Card details.`,
            `Claim form.`,
          ],
        },
        {
          type: `Heading`,
          content: `Reasons Your Claim Is Being Rejected:`,
        },
        {
          type: `Paragraph`,
          content: `There can be several reasons why your claim might be rejected by the insurer. Here are some instances that might lead to the rejection of cashless car insurance claims in India.`,
        },
        {
          type: `NumberedContent`,
          content: [
            {
              heading: `Invalid Policy`,
              para: [
                `You cannot raise a claim against an expired policy. Your policy needs to be active at the time the accident or the damages to the car took place. Car insurance companies will reject the claim even if it is raised just one day after the policy’s expiry date.`,
              ],
            },
            {
              heading: `Wrong Cover`,
              para: [
                `You cannot raise a claim for Own Damage against a Liability-only policy. You need a Comprehensive Plan for that. The moment you raise a claim, the insurer will check whether the reason the claim is raised for is covered in the policy’s inclusions or not. If it is not included, your claim will be rejected.`,
              ],
            },
            {
              heading: `Incomplete Documentation`,
              para: [
                `Due to digitisation, tech-savvy insurers do not rely too much on documentation. However, if your claim application demands specific documents such as the First Information Report (FIR for the accident), then you need to submit the same. Without such documents, the claim request won’t move ahead.`,
              ],
            },
            {
              heading: ` Disobeying the Protocol`,
              para: [
                `In the Cashless Claim process, it is crucial to wait for the insurance company’s representative to have a look at the car before it is repaired. If you repair it beforehand, the claim might not be honoured as the insurance company will not know the extent of the car’s damage first-hand.`,
              ],
            },
            {
              heading: `The Exclusions Category`,
              para: [
                `A car insurance policy comes with a set of exclusions. What this set comprises are events wherein the insurance company is not liable to pay the claim. For example, drunk driving is an exclusion. So is driving with an invalid driving license. Thus, if you raise a car accident claim and it is found that you were driving drunk or did not have a valid driving license, the insurer can reject your claim.`,
              ],
            },
          ],
        },

        {
          type: `Heading`,
          content: `How is The Cashless Claims Process Different from The Reimbursement Claims Process?`,
        },
        {
          type: `Paragraph`,
          content: `If you are wondering which is better between the cashless and the reimbursement process, then there is no definite answer. The answer depends upon your choice. For some, one might be better over another. For example, if a policyholder wants to repair the damaged car at a friend’s garage that is not a part of the insurer’s network, the policyholder might go for the Reimbursement Process.`,
        },
        {
          type: `Paragraph`,
          content: `The fundamental difference between the two processes is that the claim is majorly settled between the insurer and the garage in the cashless process. And you must get the car repaired, settle the bill with the garage, and then file a Reimbursement Claim. As per this fundamental difference, the Cashless Process does seem to score over the Reimbursement Process in terms of convenience.`,
        },
      ],
    },
  },
  {
    id: "a11",
    category: `Two Wheeler Insurance`,
    type: "articles",
    img: a11,
    date: `Oct 22,2021`,
    title: `Myths About Buying Two Wheeler Insurance Online Vs Offline`,
    article_url: `myths-about-buying-bike-insurance`,
    mainContent: `The decision to buy two-wheeler insurance online is often met with hesitation and confusion. In the absence of the physical document in the online process, you may have doubts about the genuineness of the insurance. There are myths and misconceptions that may deter you from buying insurance online. This article busts common myths about buying two-wheeler insurance online when compared to the offline method.`,
    moreContent: {
      contentData: [
        {
          type: `Heading`,
          content: `Myths About Buying Bike Insurance Online Vs. Offline
          `,
        },
        {
          type: `Paragraph`,
          content: `When it comes to shopping online, there are many misconceptions about it. Here are the myth busters of online two-wheeler insurance.`,
        },
        {
          type: `NumberedContent`,
          content: [
            {
              heading: `There is No Personal Assistance`,
              para: [
                `The fact is, digital-first insurance companies such as ACKO value their customers and strive to provide personalised care; hence, it has robust and constant and 24/7 online assistance. From information about the insurance plan to queries on the types of features, you can get details through the 24/7 customer support section of the website, or you can write to hello@acko.com or call the toll-free number 1800 266 2256.`,
              ],
            },
            {
              heading: `Buying Two-wheeler Insurance Online is Complicated`,
              para: [
                `Buying bike insurance online involves a comparatively simple process than the offline method. All you have to do is visit the website or download the mobile application, share your bike and previous policy details, and insure your vehicle instantly. It is that easy. There is no paperwork involved when you buy two-wheeler insurance at ACKO, emphasizing that buying online bike insurance is an uncomplicated process.`,
              ],
            },
            {
              heading: `One Needs to be Knowledgeable About Internet`,
              para: [
                `A basic understanding of the functioning of a computer and the internet is more than enough to buy insurance online. With internet-based smartphones, one can purchase bike insurance with a few clicks or swipes. Additionally, the number of steps is lower than that of the offline method. At ACKO, you can insure your bike instantly with a few clicks and actions.`,
              ],
            },
            {
              heading: `Buying Bike Insurance Online is Expensive`,
              para: [
                `ACKO is a new-age digital insurer striving to bust the myth that bike insurance is expensive. In fact, ACKO does not have agents or middlemen; hence, there is no commission involved and has reduced operational costs supported by solid digital infrastructure. With a direct-to-customer model and lower operating costs, ACKO can design affordable and comprehensive two-wheeler insurance plans. In addition, online insurance eliminates higher operating costs, resulting in low-cost bike insurance plans.`,
              ],
            },
            {
              heading: `Online Claim Settlement is Complex`,
              para: [
                `ACKO is one of the pioneers in offering instant claim settlements in the auto insurance industry. You can receive instant claim settlement for minor damages within a few hours. It can be a dent in the fuel tank or a broken mirror. At ACKO, all you need to do is, visit the website or the app, upload the pictures of the damaged vehicle and receive on-account payment. You can then repair the damages at a garage of your choice.`,
                `Even if damages are significant, raise the claim on the website/app by sharing the details of the damaged vehicle with the claims team, and they will guide you through the necessary steps.`,
              ],
            },
            {
              heading: `Choices Are Limited`,
              para: [
                `On the contrary, online lets you compare different insurance plans, add-on covers, and services, giving you the power to choose suitable bike insurance for your vehicle. All you need to do is, share a few details of your bike and get tailor-made insurance plans. Buying bike insurance online provides a wide range of insurance plans and their benefits so that you can make an informed decision.`,
              ],
            },
            {
              heading: `Online Bike Insurance is Not Safe`,
              para: [
                `No one wants to be cheated. Companies such as ACKO are registered with the Insurance Regulatory and Development Authority of India (IRDAI) and have a robust security system in place. You can transact online without any fear since it offers the most secure environment to buy insurance online. `,
                `The offline method of buying insurance through an agent or middlemen, whom you might not know personally can be hard and their biases may also result in making a wrong choice.`,
              ],
            },
            {
              heading: `May Misuse Personal Information`,
              para: [
                `Insurers such as ACKO work in accordance with Secure Socket Layer (SSL) server protocols. It is designed to perform cryptographic functions to enable a secure environment. The exchange of personal details and transactions on the website happen through the SSL channel and are protected and encrypted with digital signatures, making it a safe mode of buying bike insurance online.`,
              ],
            },
          ],
        },
        {
          type: `Heading`,
          content: `Conclusion`,
        },
        {
          type: `Paragraph`,
          content: `The online mode of buying bike insurance is here to make your life easier, hassle-free, and offer affordable insurance plans. Hence, you must consider buying two-wheeler insurance online over the offline method for the convenience and benefits it provides. Online is here to stay and enables you to get access to comprehensive insurance coverage for your two-wheeler at an affordable rate, along with the ease of transacting with the insurer.`,
        },
      ],
    },
  },
  {
    id: "a12",
    category: `Health Insurance`,
    type: "articles",
    img: a12,
    date: `Apr 12,2021`,
    title: `Pitfalls of Not Buying Health Insurance Plan - Reasons`,
    article_url: `consequences-of-not-having-medical-insurance`,
    mainContent: `Health insurance might not be mandatory. However, the consequences of not buying a health insurance plan for you and your family can have devastating effects on your finances. The recent coronavirus pandemic is an excellent example of how it has pushed patients or dependents to the brink of debt due to the soaring cost of getting high-quality healthcare treatment.
    <br/><br/>
    Medical insurance is a necessity and not a luxury. That is why new-age digital insurance companies such as ACKO strive hard to provide a paperless and hassle-free experience, making it easier for customers to buy, renew policies and raise claims. The online health insurance policy method of insuring is the future as it offers convenience, speed, and immediate resolutions to your queries.
    <br/><br/>
    The article provides an insight into the disadvantages of not securing yourself and your family with a health insurance plan.`,
    moreContent: {
      contentData: [
        {
          type: `Heading`,
          content: `Reasons People Don’t Buy Health Insurance Plan`,
        },
        {
          type: `Paragraph`,
          content: `Despite being a lifesaver, people do not invest in health insurance policies due to a lack of awareness of its benefits. Here are some of the reasons why people skip buying a medical insurance policy.`,
        },
        {
          type: `SMallHeading`,
          content: `Lack of Awareness`,
        },
        {
          type: `Paragraph`,
          content: `The traditional method of buying health insurance is tedious and difficult to understand, thanks to numerous paperwork and complex terms and conditions. Add to that are the agents, leaving you confused about the right plan.`,
        },
        {
          type: `Paragraph`,
          content: `As medical insurance is not mandatory in India, people do not consider it vital to them and their families. They want returns for their investment. Since health insurance benefits are invisible, people consider it futile to invest in health insurance`,
        },
        {
          type: `Paragraph`,
          content: `With rising healthcare costs and how the recent Covid-19 pandemic has dealt a blow to the finances of those affected by the high prices, it is prudent to invest in a health insurance plan.`,
        },
        {
          type: `SMallHeading`,
          content: `Half-hearted Approach to Health`,
        },
        {
          type: `Paragraph`,
          content: `Young adults, especially salaried individuals, tend to delay their investment in a health insurance plan. While young adults are fitter and healthier than older people, health care during emergencies such as a pandemic or an accident is required by the young and old alike.`,
        },
        {
          type: `Paragraph`,
          content: `While an employer may provide group medical insurance coverage, that is non-customisable, a customisable individual health insurance plan will certainly come to your rescue if you are laid off from your job when you do not have health insurance to back you during unplanned hospitalisation.`,
        },
        {
          type: `Paragraph`,
          content: `Whether you are young, old, or have a family, it is crucial to secure your finances with a robust health insurance plan as it comes to your rescue during emergencies.`,
        },
        {
          type: `SMallHeading`,
          content: `Myths About Affordability`,
        },
        {
          type: `Paragraph`,
          content: `Health insurance requires payment of premiums regularly. It can be yearly or monthly. Several people feel they cannot afford to pay premiums regularly that do not provide any returns. This can be counterproductive since health insurance certainly comes to your rescue during hospitalisation, whether for a minor or major treatment.`,
        },
        {
          type: `Paragraph`,
          content: `Modern digital insurers such as ACKO provide affordable health insurance plans along with a seamless experience while buying, renewing policies, or raising claims. Since all transactions are on the digital platform, the process is much faster and easier than traditional methods.`,
        },
        {
          type: `Paragraph`,
          content: `With a digital infrastructure and a direct-to-customer model, operational costs are reduced considerably, enabling ACKO to design affordable and comprehensive health insurance plans.`,
        },
        {
          type: `Heading`,
          content: `Consequences of Not Buying Health Insurance Plan`,
        },
        {
          type: `Paragraph`,
          content: `
          Uninsured people suffer significant financial and health consequences as a result of not having health insurance. While there is no rule that you should buy health insurance compulsorily, the risk of being uninsured is significant. Here are the risks involved in not securing yourself and your family with a health insurance policy.`,
        },
        {
          type: `SmallHeading`,
          content: `High Health Care Expenses`,
        },
        {
          type: `Paragraph`,
          content: `Without the coverage of medical insurance, an unplanned hospitalisation or a severe accident that requires an expensive treatment plan and/or emergency care can result in high health care expenses. An accident or a cancer diagnosis, or even a broken limb can cost thousands of rupees out-of-pocket.`,
        },
        {
          type: `Paragraph`,
          content: `With a massive medical bill, you are less likely to save money and more susceptible to a huge debt. It can lead to foregoing necessities and even borrowing money to pay for the medical bill or fund the debt.`,
        },
        {
          type: `SmallHeading`,
          content: `Unable to Afford Needed Medication`,
        },
        {
          type: `Paragraph`,
          content: `Because of rising medicine and health care prices, several treatments or medications are incredibly expensive, especially without a health insurance policy to cover the expenses. There are chances that you may defer the treatment or choose lower-cost medical treatment.`,
        },
        {
          type: `Paragraph`,
          content: `Yours and your family’s health is essential; hence, you must secure it with a health insurance plan so that you do not miss out on high-quality health care and medications. Health insurance will protect you financially against high health care costs and drugs required for both planned and unplanned hospitalisation.`,
        },
        {
          type: `SmallHeading`,
          content: `Worried About Unforeseen Illness`,
        },
        {
          type: `Paragraph`,
          content: `While you may have control over planned hospitalisation, unplanned hospitalisation due to an unforeseen illness or an accident can severely impact your finances. It is better to be prepared than worry about it when you have to seek medical care without any financial protection of a health insurance plan.`,
        },
        {
          type: `Paragraph`,
          content: `By securing yourself and your family with health insurance, you can be assured that you are financially protected against an unforeseen illness or even a pandemic such as Covid-19.`,
        },
        {
          type: `SmallHeading`,
          content: `Loss of Savings`,
        },
        {
          type: `Paragraph`,
          content: `The government encourages people to buy health insurance policies and provides them with tax exemption on the premiums. By not purchasing a health insurance plan, you could potentially lose your hard-earned money as income tax.`,
        },
        {
          type: `Paragraph`,
          content: `By investing in a health insurance plan, you can claim tax benefits under Section 80D of the Income Tax Act, thereby saving you money.`,
        },
        {
          type:`Heading`,
          content:`Conclusion`,
        },
        {
          type: `Paragraph`,
          content: `Health care is expensive even if you have a health insurance policy. However, those who skip buying a health insurance policy will be at a much more significant disadvantage. The inability to get treatment for health conditions and the massive medical costs are two of the biggest reasons for you to secure yourself and your family with a health insurance plan.`,
        },
      ],
    },
  },
  {
    id: "e1",
    category: `Car Insurance`,
    type: "ebooks",
    img: e1,
    title: `Complete Guide to Car Insurance Policy [E-Book]`,
  },
  {
    id: "e2",
    category: `Car Insurance`,
    type: "ebooks",
    img: e2,
    title: `Car Insurance Add-ons [E-Book]`,
  },
  {
    id: "e3",
    category: `Group Health Insurance`,
    type: "ebooks",
    img: e3,
    title: `Creating a Rewarding Workplace Culture [E-book]`,
  },
  {
    id: "e4",
    category: `Group Health Insurance`,
    type: "ebooks",
    img: e4,
    title: `Introducing ACKO Health [E-Book]`,
  },
  {
    id: "e5",
    category: `Group Health Insurance`,
    type: "ebooks",
    img: e5,
    title: `Power to Personalise [E-Book]`,
  },
  {
    id: "e6",
    category: `Two Wheeler Insurance`,
    type: "ebooks",
    img: e6,
    title: `Getting Started with Bike Insurance [E-book]`,
  },
  {
    id: "e7",
    category: `Car Insurance`,
    type: "ebooks",
    img: e7,
    title: `Decoding Vehicle Insurance Terminologies [E-Book]`,
  },
  {
    id: "e8",
    category: `Group Health Insurance`,
    type: "ebooks",
    img: e8,
    title: `Mental health in cities and why It needs attention [E-book]`,
  },
  {
    id: "e9",
    category: `Health Insurance`,
    type: "ebooks",
    img: e9,
    title: `How to select health insurance`,
  },
  {
    id: "e10",
    category: `Health Insurance`,
    type: "ebooks",
    img: e10,
    title: `Smart ways to save health insurance premium [E-book]`,
  },
  {
    id: "e11",
    category: `Health Insurance`,
    type: "ebooks",
    img: e11,
    title: `Cashless vs Reimbursement Claims [E-Book]`,
  },
];
export { mainContentData, resourceData, resourceCategories };
